import { render, staticRenderFns } from "./NoDataConfigured.vue?vue&type=template&id=4b3f69c0&scoped=true&"
import script from "./NoDataConfigured.vue?vue&type=script&lang=js&"
export * from "./NoDataConfigured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f69c0",
  null
  
)

/* custom blocks */
import block0 from "./NoDataConfigured.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports